<template>
  <div>
    <el-card shadow="never">
      <div slot="header" class="clearfix">
        <span>{{ $l('form_label_location_detail') || '详细信息' }}</span>
        <el-button
          type="text"
          style="float: right; padding: 3px 9px"
          @click="del()"
          v-if="allow('D')"
        >
          {{ $l('INDEX.btn_tips_del') || '删除' }}
        </el-button>
        <el-button
          type="text"
          style="float: right; padding: 3px 0px"
          @click="add()"
          v-if="allow('A')"
        >
          {{ $l('INDEX.btn_add') || '新增' }}
        </el-button>
        <el-button
          type="text"
          style="float: right; padding: 3px 0px"
          @click="addBatchVisible = true"
          :disabled="!isAddBatch"
          v-if="allow('P')"
        >
          {{ $l('btn_addBatch') || '批量新增' }}
        </el-button>
        <el-button
          type="text"
          style="float: right; padding: 3px 0px"
          @click="edit()"
          v-if="allow('M')"
        >
          {{ $l('INDEX.btn_tips_edit') || '编辑' }}
        </el-button>
      </div>
      <EditForm ref="editForm" />
    </el-card>

    <AddBatch :visible.sync="addBatchVisible" @reload="$emit('reload')" />
  </div>
</template>
<script>
import EditForm from '../edit-form/index.vue'
import AddBatch from '../add-batch'
import store from '../../store'
export default {
  components: { EditForm, AddBatch },
  data() {
    return { addBatchVisible: false }
  },
  computed: {
    selected() {
      return store.state.selected
    },
    isAddBatch() {
      return this.selected.isLast !== 'Y'
    },
  },
  methods: {
    edit() {
      this.$refs.editForm.openEdit()
    },
    add() {
      this.$refs.editForm.openAdd()
    },
    del() {
      this.$refs.editForm.openDel()
    },
  },
}
</script>
